import { useAuthSessionQuery } from "../../utils/useAuthSessionQuery";
import { Outlet } from "react-router-dom";
export default function Initializer() {
  const { isLoading } = useAuthSessionQuery();
  if (isLoading) {
    return <p>Loading...</p>;
  }

  return <Outlet />;
}
